<template>
  <span
    class="publish-status-label"
    :class="`publish-status-label--${value.toLowerCase()}`"
  >
    {{ text }}
  </span>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    text() {
      switch (this.value) {
        case 'PUBLISHED':
          return '已發佈';
        case 'PENDING':
          return '待發佈';
        case 'DRAFT':
          return '草稿';
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.publish-status-label {
  width: 100%;
  display: inline-block;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;

  &--published {
    background: #e0effd;
    color: #3379ba;
  }

  &--pending {
    background: #feebd9;
    color: #ac6b2d;
  }

  &--draft {
    background: #d8eee7;
    color: #538d82;
  }
}
</style>
